










































import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';
import { notNullOrUndefined } from '@/utility/functions';

@Component
export default class DetailRow extends Vue {
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) value!: string;
  @Prop({ default: 4 }) leftColumnSize!: number;
  @Prop({ default: 8 }) rightColumnSize!: number;
  @Prop({ default: null }) route!: Record<string, unknown>;
  @Prop({ default: false }) preformatted!: boolean;
  @Prop({ default: false }) colourBoolean!: boolean;

  get routingEnabled(): boolean {
    const result: boolean = notNullOrUndefined(this.route);
    return result;
  }
}
